import { useState, useEffect, useCallback } from "react";
import { requestAxios } from "../../config";
import { POST } from "./useAjaxRequest";

const request = requestAxios.create({
  baseURL: "/_layouts/15/gcs/_api",
  timeout: 1000 * 30,
});

const useSharePointHandlerRequest = (params) => {
  const { initialValue } = {
    initialValue: null,
    ...params,
  };

  const [response, setResponse] = useState({
    data: initialValue,
    error: null,
  });

  const [loading, setLoading] = useState(false);

  const performRequest = useCallback(async (config) => {
    await setLoading(true);

    const { method, headers } = { ...config };

    return request
      .request({
        ...config,
        headers: {
          "content-type": "application/json",
          ...(method
            ? { "X-HTTP-Method-Override": method.toUpperCase() }
            : null),
          ...headers,
        },
      })
      .then(({ data }) => {
        setResponse((current) => ({
          ...current,
          data,
          error: null,
        }));
        return Promise.resolve(data);
      })
      .catch((err) => {
        setResponse((current) => ({
          ...current,
          data: null,
        }));

        return Promise.reject(err);
      })
      .finally(async () => {
        await setLoading(false);
      });
  }, []);

  useEffect(() => {
    const sharePointRequestInterceptor = request.interceptors.request.use(
      async (config) => {
        return {
          ...config,
          method: POST.toUpperCase(),
        };
      },
      (err) => {
        return Promise.reject(err);
      }
    );

    const sharePointResponseInterceptor = request.interceptors.response.use(
      (res) => {
        return res;
      },
      async (err) => {
        await setResponse((current) => ({
          ...current,
          error: err,
        }));
        return Promise.reject(err);
      }
    );

    return () => {
      request.interceptors.request.eject(sharePointRequestInterceptor);
      request.interceptors.response.eject(sharePointResponseInterceptor);
    };
  }, []);

  return { response, loading, performRequest };
};
export default useSharePointHandlerRequest;
